export default {"src":"/evde-internet/_next/static/media/Vector.1c6b2c73.svg","height":20,"width":20};